export default __webpack_public_path__ + "static/media/chooseDistribution.b092258b.svg";